/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  // BASE_URL: 'http://127.0.0.1:1400/',
  BASE_URL: 'https://restaurantapi.fieldtoforks.com/',
  STRIPE_PK: 'pk_live_51H5ev5AdXVwBVNhVBkEa8Dbyn30531CcYrLqYUzBklLkntJQK3aB8G84CAgywKm9PcjKMT9XeDgE9u5xpj2nB5lP00JMAbO2Wy',
  ONESIGNAL_APP_ID:'c411420c-0d98-4cc6-8bbd-f59c073ee912'
};
